import { render, staticRenderFns } from "./PerformsAreaReportView.vue?vue&type=template&id=897654ae&scoped=true"
import script from "./PerformsAreaReportView.vue?vue&type=script&lang=js"
export * from "./PerformsAreaReportView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "897654ae",
  null
  
)

export default component.exports